import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/assortment/banners')({
  staticData: {
    title: 'route.assortment.banners',
    crumb: 'route.assortment.banners',
    permissions: ['assortment_banners_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
